import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addBaseAccountEvmExtension } from '../baseAccount/addBaseAccountEvmExtension';
export type { AddBaseAccountEvmExtensionOptions } from '../baseAccount/baseAccount.types';
